import React from "react";
import { loadStripe, Stripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const stripePromise: Promise<Stripe | null> = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!);

stripePromise.then((stripe) => {
  if (!stripe) {
    console.error("Stripe failed to initialize.");
  }
}).catch((error) => {
  console.error("Error loading Stripe:", error);
});

type StripeProviderProps = {
  children: React.ReactNode;
};

export const StripeProvider = ({ children }: StripeProviderProps) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};
